import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { ErrorResponse } from '@/types/apiTypes';
import { useMutation } from '@tanstack/react-query';

export const useSubmitFormMutation = () => {
  const [query] = useSearchQuery();
  const clientId = query.get(CLIENT_ID_QUERY_KEY);
  const { doFetch: submitForm } = useFetch<void, void>();

  return useMutation<void, ErrorResponse<unknown>, void>({
    mutationFn: () => submitForm(`/api/clients/flag/publish/${clientId}`, { method: 'PATCH' }),
  });
};